// Check and get the resource ID's i.e. the group element that has the
// ID element on it
export function getResourceId(element: SVGElement | null): string | null {
  if (!element) {
    return null;
  }
  const id = element.hasAttribute("data-resource-id")
    ? element.getAttribute("data-resource-id")
    : element.hasAttribute("id")
      ? element.getAttribute("id")
      : null;
  return id !== null && id.startsWith("reso_") ? id : null;
}
